import React, { memo } from 'react';

interface RippleProps {
  mainCircleSize?: number;
  mainCircleOpacity?: number;
  numCircles?: number;
  className?: string;
}

const Ripple = memo(function Ripple({
  mainCircleSize = 210,
  mainCircleOpacity = 0.24,
  numCircles = 8,
  className = '',
}: RippleProps) {
  return (
    <div
      className={`pointer-events-none absolute inset-0 select-none overflow-hidden ${className}`}
      style={{
        maskImage: 'linear-gradient(to bottom, white 70%, transparent)',
        WebkitMaskImage: 'linear-gradient(to bottom, white 70%, transparent)',
      }}
    >
      {Array.from({ length: numCircles }, (_, i) => {
        const size = mainCircleSize + i * 80;
        const opacity = mainCircleOpacity - i * 0.02; // Slower fade for visibility
        const animationDelay = `${i * 0.06}s`;

        return (
          <div
            key={i}
            className="absolute rounded-full border bg-matcha-500/5 shadow-md animate-ripple"
            style={{
              width: `${size}px`,
              height: `${size}px`,
              opacity: Math.max(0, opacity),
              animationDelay,
              borderWidth: '2px',
              borderStyle: 'solid',
              borderColor: 'rgba(74, 103, 65, 0.4)', // Stronger color
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%) scale(1)',
            }}
          />
        );
      })}
    </div>
  );
});

export default Ripple;
